module.exports = __webpack_public_path__ + "static/EuclidCircularB-Medium-WebS-918e6c006ecd266e527b1447c132f663.woff";